var React = require('react');

function EyeHidePurple (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#5b00db","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M9.972 17.77a8.797 8.797 0 0 0 2.028.24c5.737 0 9.834-5.838 9.834-5.838s-1.183-1.685-3.168-3.245M16.492 7.508C15.17 6.818 13.653 6.333 12 6.333c-5.736 0-9.833 5.839-9.833 5.839s1.982 2.823 5.118 4.544","key":0}),React.createElement("path",{"d":"M12 15.342a3.333 3.333 0 0 0 3.334-3.333M14.353 9.648a3.333 3.333 0 0 0-4.715 4.713M22 2 2 22","key":1})]));
}

EyeHidePurple.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = EyeHidePurple;

EyeHidePurple.default = EyeHidePurple;
